export enum EnabledTabs {
    SUMMARY = "Summary",
    ROSTER = "Roster",
    WAIVERS = "Waivers",
}
export interface RosterExportPreference {
    enabledTabs: Array<"Summary" | "Roster" | "Waivers">;
    eventData: EventData[];
    reservationData: ReservationData[];
    waiversData: WaiverData[];
}

export enum EventData {
    EVENT_CAPACITY = "Event capacity",
    TOTAL_BOOKED = "Total reserved",
    WAIVERS_SIGNED = "Waivers signed",
    EVENT_NOTES = "Roster Notes",
    GUIDES = "Guides",
    EQUIPMENT_USED = "Equipment used",
    ADDONS = "Addons",
    TOTAL_WEIGHT = "Total Weight",
}

export const EventDataCopy = {
    [EventData.EVENT_CAPACITY]: "Event capacity",
    [EventData.TOTAL_BOOKED]: "Total reserved",
    [EventData.WAIVERS_SIGNED]: "Waivers signed",
    [EventData.EVENT_NOTES]: "Event Notes",
    [EventData.GUIDES]: "Guides",
    [EventData.EQUIPMENT_USED]: "Equipment used",
    [EventData.ADDONS]: "Addons",
    [EventData.TOTAL_WEIGHT]: "Total Weight",
};

export enum ReservationData {
    NAME = "Name",
    EMAIL = "Email",
    PHONE = "Phone",
    DEMOGRAPHICS = "Demographics",
    DEMOGRAPHICS_TOTAL = "Demographics Total",
    EQUIPMENT_USED = "Equipment used",
    WAIVERS = "Waivers",
    PAYMENT_STATUS = "Payment Status",
    BOOKING_NOTES = "Purchase Notes",
    COUPON = "Coupon",
    CHECKED_IN = "Checked In",
    ADDONS = "Addons",
    QUESTIONNAIRE = "Questionnaire",
}

export const ReservationDataCopy = {
    [ReservationData.NAME]: "Name",
    [ReservationData.EMAIL]: "Email",
    [ReservationData.PHONE]: "Phone",
    [ReservationData.DEMOGRAPHICS]: "Demographics",
    [ReservationData.DEMOGRAPHICS_TOTAL]: "Demographics Total",
    [ReservationData.EQUIPMENT_USED]: "Equipment used",
    [ReservationData.WAIVERS]: "Waivers",
    [ReservationData.PAYMENT_STATUS]: "Payment Status",
    [ReservationData.BOOKING_NOTES]: "Purchase Notes",
    [ReservationData.COUPON]: "Coupon",
    [ReservationData.CHECKED_IN]: "Checked In",
    [ReservationData.ADDONS]: "Addons",
    [ReservationData.QUESTIONNAIRE]: "Questionnaire",
};

export enum WaiverData {
    NAME = "Name",
    EMAIL = "Email",
}

export const WaiverDataCopy = {
    [WaiverData.NAME]: "Name",
    [WaiverData.EMAIL]: "Email",
};
